function IconRotateReverse() {
  return (
    <svg viewBox="0 0 50 50">
      <path d="M16.05,21.79a6.79,6.79,0,0,1,.85-2A9.06,9.06,0,0,1,24.83,15h0A9.34,9.34,0,0,1,34,24.5h0A9.34,9.34,0,0,1,24.83,34h0a9.15,9.15,0,0,1-8.72-6.52M15,18v4.42h4.28" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

export default IconRotateReverse;
